import client from '../apollo';

export default async (query, variables) => {
  const response = await client.query({
    query,
    variables
  });
  return response.data;
};
